import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { BonusApi } from 'src/app/shared/apis/bonus.api';
import { CSButtonComponent } from 'src/app/shared/components/cs-button/cs-button.component';
import { CSIconButtonComponent } from 'src/app/shared/components/cs-icon-button/cs-icon-button.component';
import { CSInputComponent } from 'src/app/shared/components/cs-input/cs-input.component';
import { ToastService } from 'src/app/shared/service/toast.service';

@Component({
  selector: 'app-redeem-code',
  standalone: true,
  imports: [CSInputComponent, CSButtonComponent, CSIconButtonComponent],
  templateUrl: './redeem-code.component.html',
  styleUrl: './redeem-code.component.scss',
})
export class RedeemCodeComponent {
  redeemCode: string = '';
  loading: boolean = false;
  constructor(
    private dialogRef: MatDialogRef<RedeemCodeComponent>,
    private bonusApi: BonusApi,
    private toast: ToastService,
  ) {}

  close(): void {
    this.dialogRef.close();
  }
  redeem() {
    this.loading = true;
    this.bonusApi.setExchangeReceive({ exchangeCode: this.redeemCode }).subscribe(data => {
      this.loading = false;
      if (data) {
        this.toast.show({
          title: 'Voucher Redeemed',
          message: 'Your voucher was redeemed successfully.Check your transaction history for details.',
          type: 'success',
        });
        this.close();
      } else {
        this.toast.show({ title: 'Unknown error', message: `Please try again`, type: 'fail' });
      }
    });
  }
}
